import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import EditTable from '../EditTable';
import { Link } from 'react-router-dom';

class Order extends ChemComponent {
	constructor(props) {
		super(props);
		
		var state = {
			statusColumns: this.copyColumns(statusColumns),
			shopping_cart: {},
			unfilled: [],
			filled: [],
			editorsOpen: [],
			editorIdx: {},
			renderKey: 0
		};
		
		if (props.user.reuse && props.user.reuse.authLevel > 0) {
			// for admins, pass along whatever (if anything) is in the props
			if (props.editable !== undefined && props.editable !== null) {
				state.editable = props.editable;
			}
		} else {
			// non-admins can't edit orders
			state.editable = false;
			
			// not necessary to display email comment input
			var emailIdx = this.findColumnByAccessor(state.statusColumns, 'shopping_cart.EMAIL_COMMENTS');
			state.statusColumns.splice(emailIdx, 1);
		}
			
		this.state = state;
	}	

	componentDidMount() {
		this.loadOrder();
	}

	loadOrder(event) {
		var self = this;
		var url = this.getConfig().host;
		var data = { __RequestVerificationToken: this.props.user.antiForgeryToken };

		if (this.props.params.cartId) {
			// look up existing order
			url += '/Reuse/GetOrder';
			data.cartid = this.props.params.cartId;
		} else if (this.props.order) {
			// create new order
			url += '/Reuse/CreateOrder';
			data.order = this.props.order;
		}
		
		this.ajax({
			type: 'post',
			url: url,
			data: data
		}).done(function (data) {
			if (data.Success) {
				var shopping_cart = data.Data.shopping_cart;
				var unfilled = data.Data.unfilled;
				var filled = data.Data.filled;
				
				// convert from mvc to js
				self.mvc2js(shopping_cart, cartColumns);
				self.mvc2js(unfilled, unfilledEditColumns);
				self.mvc2js(filled, filledEditColumns);
				
				// compose updated info
				shopping_cart.UPDATED = self.composeChangeInfo(shopping_cart.MODIF_BY, shopping_cart.MODIF_DATE);
				if (self.isEmpty(shopping_cart.UPDATED)) {
					shopping_cart.UPDATED = self.composeChangeInfo(shopping_cart.PERSON_NAME, shopping_cart.CREATE_DATE);
				}
				
				// if there is a lab location
				if (!self.isEmpty(shopping_cart.LAB_LOCATION)) {
					// append to location
					shopping_cart.LOCATION += ' (' + shopping_cart.LAB_LOCATION + ')';
				}
				
				// if there is a lab phone
				if (!self.isEmpty(shopping_cart.PHONE2)) {
					// use lab phone
					shopping_cart.CONTACT_PHONE = shopping_cart.PHONE2 + ' (lab)';
				} else {
					// use office phone
					shopping_cart.CONTACT_PHONE = shopping_cart.PHONE1 + ' (office)';
				}
				
				self.mergeState({
					shopping_cart: shopping_cart,
					unfilled: unfilled,
					filled: filled,
					renderKey: self.state.renderKey + 1
				}, () => {
					if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
					if (self.props.order) self.props.clearNewOrder();
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	onEdit(accessor, editorIsOpen, idx) {
		// copy row indeces of open editors
		var editorIdx = this.copyObject(this.state.editorIdx);
		this.setByAccessor(editorIdx, accessor, idx);
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			editorIdx: editorIdx,
			renderKey: this.state.renderKey + 1
		};

		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		
		
	onChange(accessor, value) {
		var delivery;
		var newState = this.copyObject(this.state);
		this.setByAccessor(newState, accessor, value);
		newState.renderKey = this.state.renderKey + 1;

		// if this accessor represents an EditTable
		if (['filled','unfilled'].includes(accessor)) {
			// copy row indeces of open editors
			var editorIdx = this.copyObject(this.state.editorIdx);
			// since editor is closing, remove the row index
			var editRowIdx = this.deleteByAccessor(editorIdx, accessor);
			// update editor status and indeces
			newState.editorsOpen = this.setEditorStatus(accessor, false);
			newState.editorIdx = editorIdx;
			
			// if we created a new row
			var prevStatus;
			if (editRowIdx === -1) {
				// no previous status
				prevStatus = -1;
				// new rows are appended to the unfilled array
				editRowIdx = newState.unfilled.length - 1;
				// find the max ID of existing rows
				var maxLineId = -1;
				for (var u = 0; u < editRowIdx; u++) {
					if (newState.unfilled[u].LINE_ID > maxLineId) maxLineId = newState.unfilled[u].LINE_ID;
				}
				for (var f = 0; f < newState.filled.length; f++) {
					if (newState.filled[f].LINE_ID > maxLineId) maxLineId = newState.filled[f].LINE_ID;
				}
				// set IDs of new line
				newState.unfilled[editRowIdx].CART_ID = newState.shopping_cart.CART_ID;
				newState.unfilled[editRowIdx].LINE_ID = maxLineId + 1;
			} else {
				// get previous status from current state
				prevStatus = this.getNumeric(this.state[accessor][editRowIdx].STATUS_FLAG, -1);
			}
			
			// get new status of row that was edited
			var newStatus = this.getNumeric(newState[accessor][editRowIdx].STATUS_FLAG, -1);
			
			// if user is trying to move an item from 'cancelled' to 'delivered'
			if (accessor === 'filled' && prevStatus === 7 && this.getNumeric(newState.filled[editRowIdx].STATUS_FLAG, -1) === 4) {
				// cannot move from cancelled to delivered because we need delivery info. So move to "submitted" instead
				newState.filled[editRowIdx].STATUS_FLAG = 1;
				newState.filled[editRowIdx].LINE_STATUS = 'Submitted';
			}
			
			// if an unfilled row is being delivered or cancelled
			if (accessor === 'unfilled' && [4,7].includes(newStatus)) {
				// remove the row from the unfilled table
				delivery = newState.unfilled.splice(editRowIdx, 1)[0];
				
				// if it is being delivered
				if (newStatus === 4) {
					var deliveryDate = new Date();
					
					// set the delivery date to now
					delivery.DELIV_DATE = this.dateTimeToMVC(deliveryDate);
					delivery.DELIVERED = deliveryDate.toLocaleString({
						year: '2-digit',
						month: '2-digit',
						day: '2-digit',
						hour: '2-digit',
						minute: '2-digit',
						hour12: true
					}) + (!this.isEmpty(delivery.DELIV_BY) ? (' by ' + delivery.DELIV_BY) : '');
					delivery.LOCATION = this.state.shopping_cart.LAB_LOCATION + ' to ' +
						this.state.shopping_cart.PERSON_NAME + ' on ' + deliveryDate.toLocaleString({
							year: '2-digit',
							month: '2-digit',
							day: '2-digit'
						});
					delivery.SHELF_CODE = 'OUT';
				} else {
					// item is being cancelled - clear delivery information, except shelf code
					delivery.DELIV_DATE = null;
					delivery.DELIV_BY = null;
					delivery.DELIVERED = '';
					delivery.LOCATION = '';
				}
				
				// move the row from the unfilled table to the filled table
				newState.filled.push(delivery);
				
				// renumber id's for both tables
				this.renumberIDs(newState.unfilled);
				this.renumberIDs(newState.filled);
			} else if (accessor === 'filled' && ![4,7].includes(newStatus)) {
				// a filled row is being un-delivered or un-cancelled
				delivery = newState.filled.splice(editRowIdx, 1)[0];
				
				// clear delivery fields
				delivery.DELIV_DATE = null;
				delivery.DELIV_BY = null;
				delivery.DELIVERED = '';
				delivery.LOCATION = '';
				delivery.SHELF_CODE = '';
				
				newState.unfilled.push(delivery);
				
				// renumber id's for both tables
				this.renumberIDs(newState.unfilled);
				this.renumberIDs(newState.filled);
			}
			
			// last step... determine status of order
			if (newState.unfilled.length === 0 && this.getNumeric(newState.shopping_cart.STATUS_FLAG, 2) === 2) {
				// all rows have been filled but status is open (or empty)... change it to closed
				newState.shopping_cart.STATUS_FLAG = 5;
			} else if (newState.unfilled.length > 0 && this.getNumeric(newState.shopping_cart.STATUS_FLAG, 0) !== 2) {
				// there are unfilled rows but the status is not open... change it to open
				newState.shopping_cart.STATUS_FLAG = 2;
			}
		}
		
		this.setState(newState);
	}
	
	renumberIDs(table) {
		for (var i = 0; i < table.length; i++) {
			table[i].id = i;
		}
	}
	
	onCanDeleteLine(line) {
		// lines can't be deleted, only cancelled
		return false;
	}
	
	onSubmit(event) {
		var self = this;
		
		// prevent user from saving if an editor is open
		if (this.state.editorsOpen.includes('unfilled') || this.state.editorsOpen.includes('filled')) {
			this.showAlert('Editor Open', 'Please close item editor(s) before saving.');
		} else {
			var order = {
				shopping_cart: this.copyObject(this.state.shopping_cart),
				cart_item: [...this.state.unfilled, ...this.state.filled]
			};

			this.ajax({
				type: 'POST',
				url: this.getConfig().host + '/Reuse/UpdateOrder',
				overlay: true,
				data: { __RequestVerificationToken: this.props.user.antiForgeryToken, order: order }
			}).done(function (data) {
				if (data.Success) {
					self.props.parent.showConfirmation(() => {
						return (<>
							Order <Link to={'/Reuse/Orders/' + (self.props.params.orderId || data.ID)}>{self.props.params.orderId || data.ID}</Link> updated.
						</>);
					});
				} else {
					self.showAlert('Server Error', data.Message);
				}
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						  <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Order {this.state.shopping_cart.CART_ID} for {this.state.shopping_cart.PERSON_NAME}</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ borderBottom: '1px solid #eee' }}>
						<ChemEdit parent={this} user={this.props.user} columns={cartColumns} data={this.state.shopping_cart} renderKey={this.state.renderKey} editable={false} />
					  </Col>
					</Row>
					<Row>
					  <Col>
						<div style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Unfilled Orders</div>
					  </Col>
					</Row>
					<Row>
					  <Col>
						<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={newUnfilled}
						  data={this.state.unfilled} editable={this.state.editable} tableColumns={unfilledTableColumns} 
						  editColumns={unfilledEditColumns} tableName='Reuse_Order_Unfilled'
						  onCanDelete={(line) => this.onCanDeleteLine(line)}
						  onEdit={(editorIsOpen, idx) => this.onEdit('unfilled', editorIsOpen, idx)}
						  onChange={(data, callback) => this.onChange('unfilled', data)} />
					  </Col>
					</Row>
					<Row>
					  <Col>
						<div style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Filled Orders</div>
					  </Col>
					</Row>
					<Row>
					  <Col>
						<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
						  data={this.state.filled} editable={this.state.editable} tableColumns={filledTableColumns} 
						  editColumns={filledEditColumns} tableName='Reuse_Order_Filled' 
						  onCanDelete={(line) => this.onCanDeleteLine(line)}
						  onEdit={(editorIsOpen, idx) => this.onEdit('filled', editorIsOpen, idx)}
						  onChange={(data, callback) => this.onChange('filled', data)} />
					  </Col>
					</Row>
					<Row>
					  <Col>
						<div style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Order Status</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ borderBottom: '1px solid #eee' }}>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.statusColumns} data={this.state} editable={this.state.editable}
							renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChange(accessor, value)} />
					  </Col>
					</Row>
					<Form.Group as={Row}>
					  <Col style={{ paddingTop: '10px' }}>
					    <Button id="save" variant="warning" type="button" className="float-end" 
							onClick={(event) => this.onSubmit(event)}>Save</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const cartColumns = [
	{ Header: 'Group', accessor: 'RES_GROUP', row: 0, col: 0 },
	{ Header: 'Placed', accessor: 'CREATE_DATE', row: 0, col: 1 },
	{ Header: 'Deliver to', accessor: 'LOCATION', row: 1, col: 0 },
	{ Header: 'Contact Phone', accessor: 'CONTACT_PHONE', row: 1, col: 1 },
	{ Header: 'Email', accessor: 'EMAIL', row: 2, col: 0,
		Cell: props => <div style={{ paddingTop: '6px' }}><a href={'mailto:' + props.value}>{props.value}</a></div> },
	{ Header: 'Last Updated', accessor: 'UPDATED', row: 2, col: 1 }
];

const newUnfilled = {
	id: null,
	ITEM_ID: null,
	BOTTLE_ID: null,
	CHEM_NAME: null,
	CAS_NUMBER: null,
	SHELF_CODE: null,
	LOCATION: 'Reuse',
	CARE_OF: null,
	DELIVERED: null,
	LINE_STATUS: null
};

const unfilledTableColumns = [
	{ Header: '', accessor: 'ITEM_ID', show: false },
	{ Header: 'Bottle', accessor: 'BOTTLE_ID', Cell: props => <Link to={'/Reuse/Bottles/' + props.row.values.ITEM_ID}>{props.value}</Link> },
	{ Header: 'Chemical', accessor: 'CHEM_NAME' },
	{ Header: 'CAS Number', accessor: 'CAS_NUMBER' },
	{ Header: 'Shelf Code', accessor: 'SHELF_CODE' },
	{ Header: 'Location', accessor: 'LOCATION' },
	{ Header: 'Care of', accessor: 'CARE_OF' },
	{ Header: 'Delivery', accessor: 'DELIVERY' },
	{ Header: 'Status', accessor: 'LINE_STATUS' }
];

const unfilledEditColumns = [
	{ Header: 'Bottle', accessor: 'ITEM_ID', labelAccessor: ['BOTTLE_ID','CHEM_NAME','CAS_NUMBER','SHELF_CODE'], type: 'multicolumn', row: 0, col: 0,
		options: { value: 'ITEM_ID', label: ['BOTTLE_ID','CHEM_NAME','CAS_NUMBER','SHELF_CODE'], entity: 'REUSE.ADD_BOTTLE_MULTI_VW', order: 'CHEM_NAME',
			search: { Attribute: 'STORAGE_STATUS', Operator: '=', LongValue: 1 }}},
	{ Header: 'Chemical', accessor: 'CHEM_NAME', row: 0, col: 1, editable: false },
	{ Header: 'CAS Number', accessor: 'CAS_NUMBER', row: 0, col: 2, editable: false },
	{ Header: 'Shelf Code', accessor: 'SHELF_CODE', row: 0, col: 3, editable: false },
	{ Header: 'Location', accessor: 'LOCATION', row: 1, col: 0, editable: false },
	{ Header: 'Care of', accessor: 'CARE_OF', row: 1, col: 1 },
	{ Header: 'Delivery', accessor: 'DELIV_BY', type: 'dropdown', row: 1, col: 2,
		options: { value: 'USER_NAME', label: 'USER_NAME', entity: 'COLLEGE.DELIV_BY_SELECT_VW', order: 'USER_NAME' }},
	{ Header: 'Status', accessor: 'STATUS_FLAG', labelAccessor: 'LINE_STATUS', type: 'select', row: 1, col: 3,
		options: [{ value: null, label: 'Select...' },{ value: 1, label: 'Submitted' },
			{ value: 3, label: 'Pulled' },{ value: 4, label: 'Delivered' },{ value: 7, label: 'Cancelled' }]}
];

const filledTableColumns = [
	{ Header: '', accessor: 'ITEM_ID', show: false },
	{ Header: 'Bottle', accessor: 'BOTTLE_ID', Cell: props => <Link to={'/Reuse/Bottles/' + props.row.values.ITEM_ID}>{props.value}</Link> },
	{ Header: 'Chemical', accessor: 'CHEM_NAME' },
	{ Header: 'CAS Number', accessor: 'CAS_NUMBER' },
	{ Header: 'Shelf Code', accessor: 'SHELF_CODE' },
	{ Header: 'Location', accessor: 'LOCATION' },
	{ Header: 'Care of', accessor: 'CARE_OF' },
	{ Header: 'Delivered', accessor: 'DELIVERED' },
	{ Header: 'Status', accessor: 'LINE_STATUS' }
];

const filledEditColumns = [
	{ Header: 'Bottle', accessor: 'BOTTLE_ID', row: 0, col: 0, editable: false },
	{ Header: 'Chemical', accessor: 'CHEM_NAME', row: 0, col: 1, editable: false },
	{ Header: 'CAS Number', accessor: 'CAS_NUMBER', row: 0, col: 2, editable: false },
	{ Header: 'Shelf Code', accessor: 'SHELF_CODE', row: 0, col: 3, editable: false },
	{ Header: 'Location', accessor: 'LOCATION', row: 1, col: 0, editable: false },
	{ Header: 'Care of', accessor: 'CARE_OF', row: 1, col: 1, editable: false },
	{ Header: 'Delivered', accessor: 'DELIVERED', row: 1, col: 2, editable: false },
	{ Header: 'Status', accessor: 'STATUS_FLAG', labelAccessor: 'LINE_STATUS', type: 'select', row: 1, col: 3,
		options: [{ value: null, label: 'Select...' },{ value: 1, label: 'Submitted' },
			{ value: 3, label: 'Pulled' },{ value: 4, label: 'Delivered' },{ value: 7, label: 'Cancelled' }]}
];

const statusColumns = [
	{ Header: 'Status', accessor: 'shopping_cart.STATUS_FLAG', type: 'select', row: 0, col: 0,
		options: [{ value: null, label: 'Select...' },{ value: 2, label: 'Open' },
			{ value: 5, label: 'Closed' },{ value: 6, label: 'Archived' },{ value: 7, label: 'Cancelled' }]},
	{ Header: 'Email Comments to Send', accessor: 'shopping_cart.EMAIL_COMMENTS', type: 'textarea', row: 0, col: 1, colwidth: 6 },
	{ Header: 'Last Email Update', accessor: 'shopping_cart.LAST_STATUS_EMAIL', type: 'date', row: 0, col: 3, editable: false }
];

export default withRouter(Order);
